import * as types from '../mutation-types'
import {unionState} from '../union-state'

const state = {
	warehouses: [],
	default_warehouse: {},
	warehousesForKeeper: []
};
const actions = {

	fetchAll({ commit }) {
		return window.axios.get('Warehouses'
		).then(response => {
			commit(types.STORE_WAREHOUSES, response.data);
			return response.data;
		});
	},

	create({ commit }, { warehouse }) {
		return window.axios.post(`Warehouses`, {
            name: warehouse.name,
            notes: warehouse.notes,
		}).then(response => {
			// commit(types.STORE_ONE_WAREHOUSE, response.data)
            commit('', '')
			return response.data;
		});
	},

	update({ commit }, { warehouse }) {
		return window.axios.put(`Warehouses/${warehouse.id}`, {
			id: warehouse.id,
			name: warehouse.name,
            notes: warehouse.notes,
		}).then( response => {
			// commit(types.STORE_ONE_WAREHOUSE, response.data);
            commit('', '')
			return response.data;
		});
	},

	delete({ commit }, { id }) {
		return window.axios.delete(`Warehouses/${id}`).then(() => {
			// commit(types.DELETE_WAREHOUSE, id)
            commit('', '')
		});
	},
	getDefaultWarehouse({ commit }) {
		return window.axios.get(`Warehouses/Default`).then(response => {
			commit(types.STORE_DEFAULT_WAREHOUSE, response.data);
			return response.data;
		});
	},
	
	changeDefaultWarehouse({ commit }, newWarehouseId) {
		const config = { headers: {'Content-Type': 'application/json'} }
		return window.axios.put(`Warehouses/Default`, newWarehouseId, config).then(response => {
			commit(types.STORE_DEFAULT_WAREHOUSE, response.data);
			return response.data;
		});
	},

	fetchMaterialLinkedWithMaterial(_, { materialId }) {
		return window.axios.get(`Warehouses/${materialId}/LinkedMaterials`).then((data) => {
			return data
		})
	},

	linkedMaterial(_, { materialId, linkedMaterialId }) {
		return window.axios.post('Warehouses/LinkedMaterial', {} ,{ params: { materialId, linkedMaterialId } }).then((data) => {
			return data
		})
	},

	fetchMaterialSameBarcode(_, { barcode, materialId }) {
		return window.axios.get(`Warehouses/Barcode/${barcode}/Materials`, { params: { materialId } }).then((data) => {
			return data
		})
	},

	deleteLinkedItem(_, { materialId, linkedMaterialId }) {
		return window.axios.delete('Warehouses/LinkedMaterial', { params: { materialId, linkedMaterialId } })
	},

	GenerateBarcode(_, { warehouseId }) {
	 	return window.axios.get(`Warehouses/${warehouseId}/GenerateBarcode`).then((data) => {
			return data
		})
	},

	fetchWarehousesByIds({ commit }, { warehouseIds }) {
		return window.axios.get('warehouses/ByIds', { params: { warehouseIds } }).then(({ data }) => {
			commit(types.STORE_WAREHOUSES_FOR_WAREHOUSE_KEEPER, data)
			return data
		})
	}
};

const mutations = {
    
	[types.STORE_WAREHOUSES](state, warehouses) {
		state.warehouses = warehouses;
	},

	[types.STORE_ONE_WAREHOUSE](state, warehouse) {
		state.warehouses = unionState(state.warehouses, [warehouse]);
	},

	[types.DELETE_WAREHOUSE](state, warehouse) {
		state.warehouses = unionState(state.warehouses, [warehouse]);
	},
	[types.STORE_DEFAULT_WAREHOUSE](state, default_warehouse) {
		state.default_warehouse = default_warehouse;
	},
	[types.STORE_WAREHOUSES_FOR_WAREHOUSE_KEEPER](state, warehousesForKeeper) {
		state.warehousesForKeeper = warehousesForKeeper
	}
};

const getters = {
	getById: state => id => state.warehouses.find(t => t.id === id),
};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};

